import React, { useEffect, useState } from "react";
import "./Programs.css";
import axios from "axios";
import bannerImage1 from "../../Images/commonimg/blog1.jpg";

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get("https://isbmalumni.com/get-fourms.php");
                console.log("API Response:", response.data);

                // If blogs are inside .data (like events API)
                if (response.data && Array.isArray(response.data.data)) {
                    setBlogs(response.data.data.slice(0, 4));
                } else {
                    setBlogs([]);
                }
            } catch (err) {
                console.error("Error fetching blogs:", err);
                setError("Failed to load blogs.");
            } finally {
                setLoading(false);
            }
        };
        fetchBlogs();
    }, []);

    if (loading) return <p className="text-center">Loading blogs...</p>;
    if (error) return <p className="text-center text-danger">{error}</p>;
    if (!blogs.length) return <p className="text-center">No blogs available.</p>;

    const firstBlog = blogs[0];
    const otherBlogs = blogs.slice(1);

    return (
        <div className="blogs-section container-xxl mb-5">
            <div className="text-center mb-4 mt-5 row">
                <h2 className="elementor-heading-title col-4">LATEST BLOGS</h2>
                <p className="col-4 me-5">
                    Whether you’re considering a foundation course or an undergraduate,
                    academics is a place.
                </p>
                <a
                    aria-label="button"
                    className="col-2 text-center btn-lighter text-white text-decoration-none rounded ms-5 mb-3"
                    href="/blog" target="_blank"
                >
                    View All
                    <span>
                        <i aria-hidden="true" className="rt rt-arrow-right-regular"></i>
                    </span>
                </a>
            </div>

            <div className="row">
                {/* Blog Grid Style 1 - First Blog */}
                {firstBlog && (
                    <div className="reactheme-blog-grid2x reactheme-blog-grid blog--style1 col-6">
                        <div className="row blog-gird-item">
                            <div className="grid-item rts-blog v_1 col-12 filter_university">
                                <div className="rts-blog-post blog-v-full blog-item">
                                    <div className="single-blog-post border">
                                        <a
                                            aria-label="blog thumb"
                                            href={`/${firstBlog.id}`}  // <-- Use blog ID here
                                            target="_blank"
                                            className="blog-thumb"
                                        >
                                            <img
                                                src={
                                                    firstBlog.image && firstBlog.image.trim() !== ""
                                                        ? firstBlog.image
                                                        : bannerImage1
                                                }
                                                alt={firstBlog.title || "Blog Thumbnail"}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = bannerImage1;
                                                }}
                                            />
                                        </a>
                                        <div className="blog-content">
                                            <div className="post-meta d-flex align-items-center">
                                                {/* Author */}
                                                <div className="rt-author d-flex align-items-center me-3">
                                                    <i className="ti ti-user me-1 text-black" style={{ fontSize: "20px" }}></i> {/* user/author icon */}
                                                    {firstBlog.user_id || "admin"}
                                                </div>

                                                {/* Date */}
                                                <div className="rt-date d-flex align-items-center">
                                                    <i className="ti ti-calendar me-1 text-black" style={{ fontSize: "20px" }}></i> {/* calendar icon */}
                                                    <span>
                                                        {firstBlog.date_created
                                                            ? new Date(firstBlog.date_created).toLocaleDateString("en-GB")
                                                            : "N/A"}
                                                    </span>
                                                </div>
                                            </div>
                                            <a
                                                aria-label="blog title"
                                                href={`/${firstBlog.id}`} // <-- Use blog ID here
                                                target="_blank"
                                                className="post-title"
                                            >
                                                {firstBlog.title}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Blog Grid Style 2 - Next 3 Blogs */}
                <div className="reactheme-blog-grid2x reactheme-blog-grid blog--style2 rts-solari-blog-area-start reveal col-6">
                    <div className="row blog-gird-item">
                        {otherBlogs.map((blog, index) => (
                            <div className="grid-item rts-blog-post col-12" key={index}>
                                <div className="single-blog-post blog-item border">
                                    <div className="blog-thumb">
                                        <a aria-label="blog thumb" href={`/${blog.id}`} target="_blank">
                                            <img
                                                src={
                                                    blog.image && blog.image.trim() !== ""
                                                        ? blog.image
                                                        : bannerImage1
                                                }
                                                alt={blog.title || "Blog Thumbnail"}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = bannerImage1;
                                                }}
                                            />
                                        </a>
                                    </div>
                                    <div className="blog-content">
                                        <div className="post-meta">
                                            <div className="rt-author">
                                                <span>
                                                    <i className="ti ti-user me-1 text-black" style={{ fontSize: "20px" }}></i> {/* user/author icon */}
                                                </span>
                                                <a
                                                    href="#"
                                                    target="_blank"
                                                    className="text-black text-decoration-none"
                                                >
                                                    {blog.author || blog.user_id || "admin"}
                                                </a>
                                            </div>
                                            <div className="rt-date">
                                                <span>
                                                    <i className="ti ti-calendar me-1 text-black" style={{ fontSize: "20px" }}></i> {/* user/author icon */}
                                                </span>
                                                <span>
                                                    {blog.date_created
                                                        ? new Date(blog.date_created).toLocaleDateString("en-GB")
                                                        : "N/A"}
                                                </span>
                                            </div>
                                        </div>
                                        <a
                                            aria-label="blog title"
                                            href={`/${blog.id}`}
                                            target="_blank"
                                            className="post-title"
                                        >
                                            {blog.title}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blogs;
